import React, { useEffect, useState } from "react";
import AdvanceDataTable from "../../UI/Table/AdvanceDataTable";
import AdminLayout from "../../UI/Layout/AdminLayout";
import Spining from "../../UI/Spining/Spining";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { ADMIN_RCS_SETTING_LIST } from "../../UI/Table/ColumnConst";
import Axios from "../../../axios/Axios";
import { HOST_URL, HOST_URL_DB2, NODE_HOST_URL, NODE_HOST_URL_v1 } from "../../Dashboard/api/Api";
import { userloginDetails } from "../../Utils/AdminAuth";
import ReactDatePicker from "react-datepicker";
import { faArrowUp, faCalendarAlt, faDownload, faEye, faInfoCircle, faSearch, faSort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import RcsImage from "../../Dashboard/assets/img/rcs.svg-removebg-preview.png";
import dayjs from "dayjs";
import RcsPreview from "../../Dashboard/campaign/Rcs/RcsPreview";

const RcsAdminCampaignReport = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage.user.isAdmin;
    const subAdminPermission = lStorage?.permission?.per_value
    const [loading, setLoading] = useState(false);
    const [fromdate, setFromdate] = useState(new Date());
    const [todate, setTodate] = useState(new Date());
    const [listData, setListData] = useState([]);
    const [allusers, setAllusers] = useState([{ value: "", label: "All Users" }]);
    const [selecteduser, setSeletedusers] = useState("");
    const [openTemplatePopup, setOpenTemplatePopup] = useState(false)
    const [templateDetails, setTemplateDetails] = useState(null);
    const [templateType, setTemplateType] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [totalData, setTotalData] = useState({
        contactCount: 0,
        delivered: 0,
        failed: 0,
        sent: 0,
        read: 0,
        totalCost: 0,
    })
    const [show, setShow] = useState(false);
    const [cardDynamicDataArray, setCardDynamicDataArray] = useState({
        media: null,
        card_title: '',
        card_description: '',
        temp_suggestion: []
    })
    const [fallbackDataSms, setFallBackDataSms] = useState("");
    const [fallbackDataWhatsapp, setFallBackDataWhatsapp] = useState("");
    const [fallbackData, setFallBackData] = useState("");
    const [openAccordion, setOpenAccordian] = useState([]);
    const [routeData, setRouteData] = useState('');
    const [error, setError] = useState({
        successShow: false,
        bgColor: "",
        errorMessage: ""
    })
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "12px",
        }),
    };

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isMobile = windowWidth < 640;
    const isTablet = windowWidth >= 640 && windowWidth < 1024;

    useEffect(() => {
        fetchRcsCampaignReport();
        usersList();
        RouteDetails();
    }, []);

    const RouteDetails = () => {
        const payload = {
            user_id: userId,
            method: "retrieve",
            token: userToken,
            type: "admin",
        };

        fetch(`${HOST_URL}/route.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.success === true) {
                    setRouteData(result.data)
                }
            })
            .catch((error) => {
                console.error("Error fetching route details:", error);
            });
    }

    const fromdateHandler = (data) => {
        setFromdate(data);
    };

    const todateHandler = (data) => {
        setTodate(data);
    };

    const userHandler = (e) => {
        setSeletedusers(e.value);
    };

    const currentDate = (currentDate) => {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    const usersList = () => {
        setLoading(true);

        const payload = {
            user_id: userId,
            method: "retrieve_all_user",
            type: adminType,
            token: userToken,
        };

        fetch(`${HOST_URL}/admin_user_list.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", // ensures JSON format
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.success === true) {
                    let filterData = result.data.map((x) => ({
                        label: x.email,
                        value: x.id,
                    }));
                    setAllusers(filterData);
                } else {
                    // handle failure case if needed
                    // setAlert({
                    //   status: true,
                    //   bgColor: "danger",
                    //   errorMessage: result.message,
                    // });
                }
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const fetchRcsCampaignReport = async () => {
        setLoading(true);
        if (adminType === "admin" || (adminType === "subadmin" && subAdminPermission.report.children.read)) {
            try {
                const dataForList = {
                    user_id: userId,
                    token: userToken,
                    fromdate: currentDate(fromdate),
                    todate: currentDate(todate),
                    method: "admin_rcs_camp",
                    retr_user_id: selecteduser
                };

                const res = await Axios.post(`${NODE_HOST_URL_v1}/AdminRcs`, dataForList);
                const payload = res.data;

                if (!payload || payload.success !== true || !Array.isArray(payload.data)) {
                    setListData([]);
                    setLoading(false);
                    return;
                }

                const list = payload.data;

                // 1) detect which field contains the date/time string
                const detectDateField = (arr) => {
                    if (!arr || arr.length === 0) return null;
                    const common = ['created_at', 'campaign_date', 'campaignDate', 'date', 'timestamp', 'time'];
                    for (const key of common) {
                        if (arr.some(item => item && item[key])) return key;
                    }
                    // fallback: scan keys of first object to find any value that looks like a date string
                    const first = arr[0];
                    const dateLikeRegex = /(\d{1,2}\/\d{1,2}\/\d{2,4})|(\d{4}-\d{2}-\d{2})/;
                    for (const k of Object.keys(first)) {
                        const v = first[k];
                        if (typeof v === 'string' && dateLikeRegex.test(v)) return k;
                    }
                    return null;
                };

                const dateField = detectDateField(list);

                // 2) robust parse function for multiple formats
                const parseDate = (dateStr) => {
                    if (!dateStr) return new Date(0);

                    // if already a Date object
                    if (dateStr instanceof Date) return dateStr;

                    const s = String(dateStr).trim();

                    // try native parse (ISO etc.)
                    const isoTs = Date.parse(s);
                    if (!isNaN(isoTs)) return new Date(isoTs);

                    // regex for DD/MM/YYYY HH:MM(:SS)? [AM|PM]?
                    const re = /(\d{1,2})\/(\d{1,2})\/(\d{2,4})\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM|am|pm)?/;
                    const m = s.match(re);
                    if (m) {
                        let day = parseInt(m[1], 10);
                        let month = parseInt(m[2], 10);
                        let year = parseInt(m[3], 10);
                        if (year < 100) year += 2000; // handle yy
                        let hour = parseInt(m[4], 10);
                        const minute = parseInt(m[5], 10);
                        const second = m[6] ? parseInt(m[6], 10) : 0;
                        const ampm = m[7] ? m[7].toUpperCase() : null;

                        if (ampm === 'PM' && hour !== 12) hour += 12;
                        if (ampm === 'AM' && hour === 12) hour = 0;

                        return new Date(year, month - 1, day, hour, minute, second);
                    }

                    // fallback: try to parse patterns like "27/11/2025 16:30"
                    const re24 = /(\d{1,2})\/(\d{1,2})\/(\d{2,4})\s+(\d{1,2}):(\d{2})(?::(\d{2}))?/;
                    const m2 = s.match(re24);
                    if (m2) {
                        const day = parseInt(m2[1], 10);
                        const month = parseInt(m2[2], 10);
                        let year = parseInt(m2[3], 10);
                        if (year < 100) year += 2000;
                        const hour = parseInt(m2[4], 10);
                        const minute = parseInt(m2[5], 10);
                        const second = m2[6] ? parseInt(m2[6], 10) : 0;
                        return new Date(year, month - 1, day, hour, minute, second);
                    }

                    // as last resort, return epoch 0 so it goes to bottom
                    return new Date(0);
                };

                // 3) prepare array copy to avoid mutating original payload.data
                let workingArray = Array.from(list);

                // if selecteduser filter exists, apply it first (so totals are only for filtered items)
                if (selecteduser) {
                    workingArray = workingArray.filter(x => x.user_id === selecteduser);
                }

                // 4) sort by detected date field descending (latest first)
                if (dateField) {
                    workingArray.sort((a, b) => {
                        return parseDate(b[dateField]) - parseDate(a[dateField]);
                    });
                } else {
                    // no date field detected: fallback to original order
                }

                // 5) calculate totals
                let contactCount = 0;
                let delivered = 0;
                let failed = 0;
                let sent = 0;
                let read = 0;
                let totalCost = 0;

                workingArray.forEach((x) => {
                    contactCount += Number(x.contact_count || 0);
                    delivered += Number(x.delivered || 0);
                    failed += Number(x.failed || 0);
                    sent += Number(x.sent || 0);
                    read += Number(x.read || 0);
                    totalCost += Number(x.block_cr || 0);
                });

                setTotalData({
                    contactCount,
                    delivered,
                    failed,
                    sent,
                    read,
                    totalCost
                });

                setListData(workingArray);
                setOpenAccordian([]);
            } catch (error) {
                console.error("fetchRcsCampaignReport error:", error);
                setListData([]);
            } finally {
                setLoading(false);
            }
        }
    };



    const processContent = (text) => {
        return text.split(',' || '.').map(part => `<div>${part.trim()}</div>`).join('');
    };

    const getTemplateDetails = async (id) => {
        setShow(true);
        try {
            const { data } = await Axios.post(`${NODE_HOST_URL}/admin/rcs`, {
                token: userToken,
                user_id: userId,
                temp_id: id,
                method: "retrieve_temp_dtl",
            });

            if (data.success === true) {
                setTemplateDetails(data?.data);
                setTemplateType(data?.data?.temp_type);
            }
        } catch (err) {
            console.log(err);
        }
    };


    const toggleAccordion = async (campaignId, fallbackKey, channel) => {
        const accordionKey = `${campaignId}-${fallbackKey}`;

        // 🔹 Check current state FIRST
        const isAlreadyOpen = openAccordion.includes(accordionKey);

        // 🔹 Toggle UI
        setOpenAccordian(prev => {
            if (isAlreadyOpen) {
                return prev.filter(key => key !== accordionKey);
            }
            return [...prev, accordionKey];
        });

        // 🔹 If closing → STOP
        if (isAlreadyOpen) return;

        // 🔹 API CALL (always runs when opening)
        let paramData = {
            user_id: userId,
            token: userToken,
            method: "retrieve_new_refid",
            ref_id: campaignId,
            channel: channel
        };

        try {
            // setLoading(true);
            const { data } = await Axios.post(
                `${HOST_URL_DB2}/bulk_campaign_sms.php`,
                paramData
            );

            if (!data.success) {
                // setError({
                //     successShow: true,
                //     bgColor: "alert alert-danger",
                //     errorMessage: `Fallback record for ${campaignId} is not found`
                // })
                // setTimeout(() => {
                //     window.scrollTo({ top: 0, behavior: "smooth" });
                // }, 100);
                return
            }

            const campaignData = data.data[0];

            setListData(prevList =>
                prevList.map(campaign => {
                    if (campaign._id !== campaignId) return campaign;

                    const updatedFallback = { ...campaign.fallback_condition };
                    const fb = updatedFallback[fallbackKey];

                    if (fb && fb.channel === campaignData.campaign_type) {
                        updatedFallback[fallbackKey] = {
                            ...fb,
                            FallbackData: campaignData
                        };
                    }

                    return {
                        ...campaign,
                        fallback_condition: updatedFallback
                    };
                })
            );

        } catch (error) {
            console.log(error);
        }
        // finally {
        //     setLoading(false);
        // }
    };

    const handleSortClick = () => {
        const sorted = [...listData].sort((a, b) =>
            sortOrder === "asc"
                ? a.contact_count - b.contact_count
                : b.contact_count - a.contact_count
        );

        setListData(sorted);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };

    const handleDeliveredSort = () => {
        const sorted = [...listData].sort((a, b) =>
            sortOrder === "asc"
                ? a.delivered - b.delivered
                : b.delivered - a.delivered
        );

        setListData(sorted);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };

    const handleFailedSort = () => {
        const sorted = [...listData].sort((a, b) =>
            sortOrder === "asc"
                ? a.failed - b.failed
                : b.failed - a.failed
        );

        setListData(sorted);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };

    const handleSentSort = () => {
        const sorted = [...listData].sort((a, b) =>
            sortOrder === "asc"
                ? a.sent - b.sent
                : b.sent - a.sent
        );

        setListData(sorted);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    }

    const handleReadSort = () => {
        const sorted = [...listData].sort((a, b) =>
            sortOrder === "asc"
                ? a.read - b.read
                : b.read - a.read
        );

        setListData(sorted);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };

    const sortByDate = () => {
        const sorted = [...listData].sort((a, b) => {
            const dateA = new Date(a.camp_start_datetime);
            const dateB = new Date(b.camp_start_datetime);
            return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
        });

        setListData(sorted);
        setSortOrder(prev => (prev === 'asc' ? 'desc' : 'asc'));
    };

    const downloadRcsCampaignFile = async (item) => {
        try {
            let paramData = {
                user_id: userId,
                token: userToken,
                fromdate: currentDate(fromdate),
                todate: currentDate(todate),
                retr_user_id: item.user_id,
                method: "download_rcs_camp",
                campaign_id: item._id
            };

            const response = await Axios.post(
                `${NODE_HOST_URL_v1}/AdminRcs`,
                paramData,
                { responseType: "blob" }
            );

            // detect extension dynamically
            const contentType = response.headers["content-type"];
            let extension = "csv"; // default

            if (contentType && contentType.includes("gzip")) {
                extension = "csv.gz";
            }

            const fileName = `rcs_campaign_${item._id}.${extension}`;

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Download failed:", error);
        }
    };
    const downloadRcsCampaign = async (item) => {

        try {
            let paramData = {
                user_id: userId,
                token: userToken,
                fromdate: currentDate(fromdate),
                todate: currentDate(todate),
                retr_user_id: item.user_id,
                method: "download_rcs_camp",
                campaign_id: item._id
            }

            // 🔥 Now expecting URL, not blob
            const res = await Axios.post(`${NODE_HOST_URL_v1}/AdminRcs`, paramData);

            const fileUrl = res?.data?.download_url;

            if (!fileUrl) {
                throw new Error("Download URL not received");
            }

            // Force browser download
            const link = document.createElement("a");
            link.href = fileUrl;
            link.setAttribute("download", `rcs_campaign_${item._id}.csv.gz`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Download failed:", error);
        }
    };
    const handleDownload = (item) => {
        if (item.archive_status === 0) {
            downloadRcsCampaignFile(item);
        } else {
            downloadRcsCampaign(item);
        }
    };

    const downloadCampaign = async (item) => {
        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append("method", "download_admin");
        formData.append("token", userToken);
        formData.append("channel", "whatsapp");
        formData.append("camp_user_id", item.user_id);
        formData.append("camp_id", item.id);
        formData.append("camp_user_email", item.user_name);
        formData.append("archive_status", item.archive_status);

        try {
            const response = await fetch(`${HOST_URL}/bulk_campaign_sms.php`, {
                method: "POST",
                body: formData,
            });
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `campaign_${item.id}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("WhatsApp fallback download failed:", error);
        }
    };

    return (
        <>
            {/* {loading && <Spining />} */}
            <AdminLayout>
                <div className="row">
                    <div className="col-12 col-sm-3">
                        <h6>RCS Campaign Report</h6>
                    </div>
                    {/* <div className="col-9 mb-2">
                        <Link
                            type="button"
                            style={{
                                float: "right",
                                fontSize: "12px",
                                padding: "10px 10px 10px 10px",
                            }}
                            to={"/admin/rcs/rcs-setting-add"}
                            className="btn btn-success"
                        >
                            Add new
                        </Link>
                    </div> */}
                </div>

                {listData.length > 0 &&
                    <div className="row">
                        <div className="col-xl-12 col-xxl-5 d-flex">
                            <div className="w-100">
                                <div className="row">
                                    <div className="col-6 col-sm-4 col-md-2">
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Submission</h5>
                                                <h6 className="mt-0 mb-0">{totalData.contactCount}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-sm-4 col-md-2">
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Delivered</h5>
                                                <h6 className="mt-0 mb-0">{totalData.delivered}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-sm-4 col-md-2">
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Failed</h5>
                                                <h6 className="mt-0 mb-0">{totalData.failed}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-sm-4 col-md-2">
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Read</h5>
                                                <h6 className="mt-0 mb-0">{totalData.read}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-sm-4 col-md-2">
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Sent</h5>
                                                <h6 className="mt-0 mb-0">{totalData.sent}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-sm-4 col-md-2">
                                        <div className="card">
                                            <div className="card-body p-2 ">
                                                <h5 className="card-title mb-0">Total Cost</h5>
                                                <h6 className="mt-0 mb-0">
                                                    {parseFloat(totalData.totalCost).toFixed(2)}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}

                {/* {error.successShow ? (
                    <div className={error.bgColor} role="alert">
                        <button
                            type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                        <div className="">{error.errorMessage}</div>
                    </div>
                ) : null} */}

                <div className="row justify-content-center">
                    <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                        <div className="card flex-fill ">
                            <div className="card-header">

                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <label>Select User</label>
                                        <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                                            <div className="input-group mb-2 mr-sm-2">
                                                <Select
                                                    onChange={userHandler}
                                                    options={allusers}
                                                    isSearchable={true}
                                                    placeholder="All Users"
                                                    styles={customStyles}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <label>From:</label>
                                        <div className="input-group mb-2 mr-sm-2">
                                            <div className="input-group-text">
                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                            </div>
                                            <div>
                                                <ReactDatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="dd/MM/yyyy"
                                                    value={fromdate}
                                                    onChange={fromdateHandler}
                                                    selected={fromdate}
                                                    placeholderText="From Date"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <label>To:</label>
                                        <div className="input-group mb-2 mr-sm-2">
                                            <div className="input-group-text">
                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                            </div>
                                            <div>
                                                <ReactDatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="dd/MM/yyyy"
                                                    value={todate}
                                                    onChange={todateHandler}
                                                    selected={todate}
                                                    placeholderText="Date To"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-1">
                                        <label></label>
                                        <button
                                            className="btn btn-success float-right"
                                            onClick={fetchRcsCampaignReport}
                                        >
                                            <FontAwesomeIcon className="fa-lg" icon={faSearch} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {loading === true ? (
                                <Spining />
                            ) : (
                                <div className="col-md-12 mt-2">
                                    {listData.length === 0 && (
                                        <div className="card d-flex justify-content-center align-items-center ">
                                            <h6 className="mt-2">No Record Found</h6>
                                        </div>
                                    )}
                                    {listData?.map((item, i) => (
                                        <div className="card" key={i}>
                                            <div className="card-body">
                                                <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: isMobile ? "wrap" : "nowrap", minWidth: 0 }}>
                                                    {/* Campaign Name — grows to fill space, truncates if too long */}
                                                    <div style={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0, overflow: "hidden" }}>
                                                        <img alt="Rcs Image" className="text-primary mr-2 rcs-logo-image" style={{ fontSize: '2em', flexShrink: 0 }} src={RcsImage} />
                                                        <span style={{ flexShrink: 0, whiteSpace: "nowrap" }}>Campaign Name:</span>
                                                        <span style={{ fontWeight: "bold", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginLeft: "4px" }} title={item.campaign_name}>
                                                            {item.campaign_name}
                                                        </span>
                                                    </div>
                                                    {/* Status badge — never wraps */}
                                                    <div style={{ flexShrink: 0 }}>
                                                        {item.status === 1 ? (
                                                            <span className="badge bg-info">Processing</span>
                                                        ) : item.status === 2 ? (
                                                            <span className="badge bg-info">Schedule</span>
                                                        ) : item.status === 3 ? (
                                                            <span className="badge bg-success">Completed</span>
                                                        ) : item.status === 4 ? (
                                                            <span className="badge bg-primary">Schedule Deleted</span>
                                                        ) : null}
                                                    </div>
                                                    {/* Campaign Date — never wraps */}
                                                    <div style={{ flexShrink: 0, fontSize: "13px", whiteSpace: "nowrap" }}>
                                                        Campaign Date: {dayjs(item.camp_start_datetime).format("DD/MM/YYYY h:mm A")}
                                                        <FontAwesomeIcon className="ml-2" onClick={sortByDate} style={{ cursor: "pointer" }} icon={faSort} />
                                                    </div>
                                                </div>
                                                <hr className="m-0 mb-1"></hr>
                                                <div className="d-flex flex-wrap summary-data text-center" style={{ gap: "8px" }}>
                                                    <div className="mb-1">
                                                        <span className="text-muted"> total </span> <FontAwesomeIcon onClick={handleSortClick} style={{ cursor: "pointer" }} icon={faSort} />{" "}
                                                        <br />
                                                        <span className="textvalue text-success">
                                                            {" "}
                                                            {item.contact_count}{" "}
                                                        </span>{" "}
                                                    </div>

                                                    <div className="mb-1">
                                                        <span className="text-muted">
                                                            {" "}
                                                            Delivered{" "}
                                                        </span><FontAwesomeIcon onClick={handleDeliveredSort} style={{ cursor: "pointer" }} icon={faSort} />{" "}
                                                        <br />
                                                        <span className="textvalue text-success">
                                                            {" "}
                                                            {item.delivered}{" "}
                                                        </span>{" "}
                                                    </div>

                                                    <div className="mb-1">
                                                        <span className="text-muted"> Failed </span><FontAwesomeIcon onClick={handleFailedSort} style={{ cursor: "pointer" }} icon={faSort} />
                                                        <br />{" "}
                                                        <span className="textvalue text-success">
                                                            {" "}
                                                            {item.failed}{" "}
                                                        </span>{" "}
                                                    </div>

                                                    <div className="mb-1">
                                                        <span className="text-muted"> Sent </span><FontAwesomeIcon onClick={handleSentSort} style={{ cursor: "pointer" }} icon={faSort} />{" "}
                                                        <br />
                                                        <span className="textvalue">
                                                            {" "}
                                                            <FontAwesomeIcon
                                                                icon={faArrowUp}
                                                                color="green"
                                                                size="1x"
                                                            />{" "}
                                                            {item.sent}{" "}
                                                        </span>{" "}
                                                    </div>

                                                    <div className="mb-1">
                                                        <span className="text-muted"> Read </span><FontAwesomeIcon onClick={handleReadSort} style={{ cursor: "pointer" }} icon={faSort} />
                                                        <br />{" "}
                                                        <span className="textvalue">
                                                            {" "}
                                                            <FontAwesomeIcon
                                                                icon={faArrowUp}
                                                                color="green"
                                                                size="1x"
                                                            />{" "}
                                                            {item.read}{" "}
                                                        </span>{" "}
                                                    </div>

                                                    <>
                                                        {item.archive_status === 1 ? null : <div className="mb-1">
                                                            <span className="text-muted"> Report </span>
                                                            <br />{" "}
                                                            <Link
                                                                to={`/admin/campaign/detailed-report/rcs/${item._id}/${encodeURIComponent(item.campaign_name)}/${item.contact_count}/${currentDate(fromdate)}/${currentDate(todate)}/${item.user_name}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <span className=" text-success">
                                                                    <FontAwesomeIcon className="mt-3" icon={faEye} />
                                                                </span>
                                                            </Link>
                                                        </div>}

                                                        {/* <div className="mb-1">
                                      <span className="text-muted"> Other </span>
                                      <br />{" "}
                                      <span className="textvalue text-success">
                                        {" "}
                                        {item.other}{" "}
                                      </span>{" "}
                                    </div> */}

                                                        {(adminType === "admin" || (adminType === "subadmin" && subAdminPermission.report.children.download)) &&
                                                            <div className="mb-1">
                                                                <span className="text-muted"> Download </span>
                                                                <br />
                                                                <button
                                                                    onClick={() => handleDownload(item)}
                                                                    className="text-success btn btn-link p-0"
                                                                >
                                                                    <FontAwesomeIcon className="mt-3" icon={faDownload} />
                                                                </button>
                                                            </div>}

                                                    </>
                                                </div>
                                                <div className="d-flex justify-content-between mt-1">
                                                    <div className="d-flex flex-wrap" style={{ gap: "4px" }}>
                                                        <small className="m-0, p-0" style={{ fontSize: "10px" }}>
                                                            <span style={{ color: "black" }}>Campaign ID:</span> <span style={{ color: "#4c0af5" }}>{item._id}</span><span style={{ color: "black" }}>/</span>
                                                        </small>
                                                        {/* {this.state.channel === "sms" ? <small>Template ID:  xxxxxxxx{item?.template_id?.substr(-4,4)}/</small> :
                                                <small>Template ID: {item?.template_id}/</small>} */}
                                                        {<small style={{ color: "black", fontSize: "10px" }}>Template ID: <span style={{ color: "#4c0af5" }}>{item?.pannel_temp_id}</span><span className="no-style">/</span></small>}
                                                        {<small style={{ color: "black", fontSize: "10px" }}>Template Name: <span style={{ color: "#4c0af5" }}>{item?.template_id}</span><span className="no-style">/</span></small>}
                                                        {<small style={{ color: "black", fontSize: "10px" }}>Sender ID: <span style={{ color: "#4c0af5" }}>{item?.sender_id}</span><span className="no-style">/</span></small>}
                                                        {<small style={{ color: "black", fontSize: "10px" }}>Submit From: <span style={{ color: "#4c0af5" }}>{item?.submit_from}</span><span className="no-style">/</span></small>}
                                                        <small style={{ color: "black", fontSize: "10px" }}>
                                                            Route ID:{" "}
                                                            <span style={{ color: "#4c0af5" }}>
                                                                {
                                                                    (Array.isArray(routeData)
                                                                        ? routeData.find(x => Number(x.id ?? x.route_id) === Number(item?.route_id))?.route_name
                                                                        : routeData?.[item?.route_id]?.route_name
                                                                    ) || item?.route_id
                                                                }

                                                            </span>
                                                            <span className="no-style">/</span>
                                                        </small>

                                                        {<small style={{ color: "black", fontSize: "10px" }}>Campaign Type: <span style={{ color: "#4c0af5" }}>{item?.message_type === 1 ? "Normal" : item.message_type === 3 ? "Customize" : null}</span><span className="no-style">/</span></small>}

                                                        {/* {<small style={{ color: "black", fontSize: "12px" }}>Sender ID: <span style={{ color: "#4c0af5" }}>{item.sender_id}</span>/</small>} */}
                                                        {<small style={{ color: "black", fontSize: "10px" }}>User Name: <span style={{ color: "#4c0af5" }}>{item.user_name}</span></small>}
                                                        <small
                                                            style={{
                                                                cursor: 'pointer',
                                                                backgroundColor: openTemplatePopup ? '#f0f0f0' : 'transparent',
                                                            }}
                                                            className="ml-2"
                                                            onClick={() => getTemplateDetails(item?.pannel_temp_id)}
                                                        >
                                                            <FontAwesomeIcon icon={faInfoCircle} /></small>
                                                    </div>
                                                    {/* <small style={{ color: "black", fontSize: "12px" }}>
                                                        Campaign Cost: {" "}
                                                        <span style={{ color: "#4c0af5" }}>{parseFloat(item.block_cr).toFixed(2)}</span>
                                                    </small> */}
                                                </div>
                                                <div className="d-flex justify-content-end mt-1">
                                                    <small style={{ color: "black", fontSize: "12px" }}>
                                                        Campaign Cost:{" "}
                                                        <span style={{ color: "#4c0af5" }}>
                                                            {parseFloat(item.block_cr).toFixed(2)}
                                                        </span>
                                                    </small>
                                                </div>

                                                {item.is_fallback === 1 && (
                                                    <div className="mt-3">

                                                        {Object.keys(item?.fallback_condition || {}).map((x, index) => {

                                                            const fb = item?.fallback_condition?.[x] || {};
                                                            const fallbackData = fb?.FallbackData || null;
                                                            const accordionKey = `${item?._id}-${x}`;
                                                            const isOpen = openAccordion.includes(accordionKey);

                                                            return (
                                                                <div className="card mb-2 shadow-sm" key={x}>

                                                                    {/* ===== FALLBACK HEADER ===== */}
                                                                    <div
                                                                        className="card-header d-flex justify-content-between align-items-center"
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => toggleAccordion(item?._id, x, fb?.channel)}
                                                                    >
                                                                        <div>
                                                                            <span
                                                                                className={
                                                                                    fb?.channel === "sms"
                                                                                        ? "badge bg-success me-2"
                                                                                        : "badge bg-primary me-2"
                                                                                }
                                                                            >
                                                                                Fallback {index + 1}
                                                                            </span>

                                                                            <span className="text-muted ml-3">
                                                                                Channel:
                                                                                <b className="ms-1">
                                                                                    {fb?.channel === "whatsapp"
                                                                                        ? "WhatsApp"
                                                                                        : fb?.channel === "sms"
                                                                                            ? "SMS"
                                                                                            : "-"}
                                                                                </b>
                                                                            </span>
                                                                        </div>

                                                                        <span className="text-muted">
                                                                            {isOpen ? "▲" : "▼"}
                                                                        </span>
                                                                    </div>

                                                                    {/* ===== FALLBACK BODY ===== */}
                                                                    {isOpen && (
                                                                        <div className="card-body">

                                                                            {/* ===== STATS GRID ===== */}
                                                                            <div className="row text-center gy-3">

                                                                                <div className="col-6 col-md">
                                                                                    <small className="text-muted">Total</small>
                                                                                    <div className="fw-bold">
                                                                                        {fallbackData?.contact_count || 0}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-6 col-md">
                                                                                    <small className="text-muted">Delivered</small>
                                                                                    <div className="fw-bold">
                                                                                        {fallbackData?.delivered || 0}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-6 col-md">
                                                                                    <small className="text-muted">Failed</small>
                                                                                    <div className="fw-bold">
                                                                                        {fallbackData?.failed || 0}
                                                                                    </div>
                                                                                </div>

                                                                                {/* ===== WHATSAPP ===== */}
                                                                                {fb?.channel === "whatsapp" && (
                                                                                    <>
                                                                                        <div className="col-6 col-md">
                                                                                            <small className="text-muted">Sent</small>
                                                                                            <div className="fw-bold">
                                                                                                {fallbackData?.sent || 0}
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="col-6 col-md">
                                                                                            <small className="text-muted">Read</small>
                                                                                            <div className="fw-bold">
                                                                                                {fallbackData?.read || 0}
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                )}

                                                                                {/* ===== SMS ===== */}
                                                                                {fb?.channel === "sms" && (
                                                                                    <>
                                                                                        <div className="col-6 col-md">
                                                                                            <small className="text-muted">Opt Out</small>
                                                                                            <div className="fw-bold">
                                                                                                {fallbackData?.optout || 0}
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="col-6 col-md">
                                                                                            <small className="text-muted">DND</small>
                                                                                            <div className="fw-bold">
                                                                                                {fallbackData?.dnd || 0}
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="col-6 col-md">
                                                                                            <small className="text-muted">Other</small>
                                                                                            <div className="fw-bold">
                                                                                                {fallbackData?.other || 0}
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </div>

                                                                            {/* ===== FOOTER ===== */}
                                                                            {fallbackData && (
                                                                                <>
                                                                                    <hr />

                                                                                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">

                                                                                        <small>
                                                                                            Campaign ID:
                                                                                            <b className="ms-1">
                                                                                                {fallbackData?.id || "-"}
                                                                                            </b>

                                                                                            <span className="mx-1">|</span>

                                                                                            Cost:
                                                                                            <b
                                                                                                className={
                                                                                                    fb?.channel === "sms"
                                                                                                        ? "ms-1 text-primary"
                                                                                                        : "ms-1 text-success"
                                                                                                }
                                                                                            >
                                                                                                {parseFloat(
                                                                                                    fallbackData?.campaign_cost || 0
                                                                                                ).toFixed(2)}
                                                                                            </b>
                                                                                        </small>

                                                                                        <div className="d-flex gap-3">

                                                                                            {fallbackData?.archive_status === 0 && (
                                                                                                <Link
                                                                                                    to={
                                                                                                        fb?.channel === "whatsapp"
                                                                                                            ? `/admin/campaign-report/${fallbackData?.user_id}/${fallbackData?.id}/${fallbackData?.user_name}/${fallbackData?.contact_count}`
                                                                                                            : `/admin/campaign/detailed-report/${fb?.channel}/${fallbackData?.id}/${fallbackData?.user_name}/${fallbackData?.contact_count}`
                                                                                                    }
                                                                                                    target="_blank"
                                                                                                    className={
                                                                                                        fb?.channel === "whatsapp"
                                                                                                            ? "text-success mr-3"
                                                                                                            : "text-primary mr-3"
                                                                                                    }
                                                                                                >
                                                                                                    <FontAwesomeIcon icon={faEye} /> Report
                                                                                                </Link>
                                                                                            )}

                                                                                            {(adminType === "admin" ||
                                                                                                (adminType === "subadmin" &&
                                                                                                    subAdminPermission?.report?.children
                                                                                                        ?.download)) && (
                                                                                                    fb?.channel === "whatsapp" ? (
                                                                                                        <button
                                                                                                            onClick={() => downloadCampaign(fallbackData)}
                                                                                                            className="btn btn-link p-0 text-success"
                                                                                                        >
                                                                                                            <FontAwesomeIcon icon={faDownload} /> Download
                                                                                                        </button>
                                                                                                    ) : (
                                                                                                        <a
                                                                                                            href={`${HOST_URL_DB2}/bulk_campaign_sms.php?user_id=${userId}&ret_user_id=${fallbackData?.user_id}&method=download&token=${userToken}&channel=${fb?.channel}&campaign_id=${fallbackData?.id}&archive_status=${fallbackData?.archive_status}&camp_start_datetime=${fallbackData?.camp_start_datetime}&type=${adminType}&username=${fallbackData?.user_name}`}
                                                                                                            className="text-primary"
                                                                                                        >
                                                                                                            <FontAwesomeIcon icon={faDownload} /> Download
                                                                                                        </a>
                                                                                                    )
                                                                                                )}
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}


                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {show && (
                                <div
                                    className="position-fixed top-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                    style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050, left: 0 }}
                                >
                                    <div
                                        className="bg-white p-3 rounded shadow"
                                        style={{ maxHeight: '90vh', overflowY: 'auto', position: 'relative', width: isMobile ? '95%' : (isTablet ? '75%' : '50%') }}
                                    >

                                        <button
                                            className="btn btn-sm position-absolute close  m-2"
                                            style={{ top: '0', right: '0' }}
                                            onClick={() => setShow(false)}

                                        >
                                            <span style={{ fontSize: "1.5rem" }}>&times;</span>
                                        </button>


                                        {templateType === 'text' ? <RcsPreview temp_type={templateType} rcsContent={templateDetails.temp_body} suggestionButtons={templateDetails.temp_suggestion} /> : <RcsPreview temp_type={templateType} cardDataArray={templateDetails?.rich_card} cardDynamicDataArray={cardDynamicDataArray} />}
                                    </div>
                                </div>
                            )}
                            {/* <WhatsAppCampaignListPreview templateDetails={this.state.templateDetails} openTemplatePopup={this.state.openTemplatePopup} closePopup={this.closePopup} /> */}
                        </div>
                    </div>
                </div>
            </AdminLayout>
        </>
    );
};

export default RcsAdminCampaignReport;
